import traqing from '@yola/traqing.js';
import { traqingSegmentIdentified } from './integrations/yola-debugging-integration';

const identify = (userId, ...args) => {
  traqingSegmentIdentified();
  traqing.segment.identify(userId, ...args);
};

export default identify;
